import React, { useState } from 'react'
import ImageDialog from './Dialog/ImageDialog'

export default function ViewPdf({ image }) {
  const [open, setOpen] = useState(false)
  const [preview, setPreview] = useState(false)
  return (
    <div>
      <embed
        src={image}
        onClick={() => {
          setOpen(true)
          setPreview(image)
        }}
      />
      {preview && <ImageDialog open={open} handleClose={() => setOpen(false)} image={preview} />}
    </div>
  )
}
